module.exports = __webpack_public_path__ + "static/media/slider 2.84c7684a.png";